import { Col, Row, Button } from 'antd';
import React from 'react';
import AdminHeader from '../../globals/Layout/Admin/AdminHeader';
import TUser from './Tables/TUser';
import style from './Welcome.module.scss'
const Welcome: React.FC = () => {
    return (
        <div>
            <AdminHeader>Bienvenido</AdminHeader>
            <div className={style["title"]}>
                Acerca de Nosotros
            </div>
            <div className={style["text"]}>
                Somos un grupo de profesionales de excelencia en diferentes áreas de especialización, dedicados y apasionados por la sostenibilidad ambiental, con el fin de brindar soluciones integrales.
            </div>
            <div className={style["title"]}>
                Misión
            </div>
            <div className={style["text"]}>
                Ayudamos a nuestros clientes a desarrollar estrategias, implementar acciones y evaluar el desempeño ambiental, con el fin de lograr la sostenibilidad.
            </div>
            <div className={style["title"]}>
                Visión

            </div>
            <div className={style["text"]}>
                Vivir en un mundo donde exista un futuro para todos.
            </div>
            <div className={style["title"]}>
                Nuestros Valores y Principios
            </div>
            <div className={style["text"]}>
                <ul>
                    <li>Brindar a nuestros clientes un servicio mejor al esperado.</li>
                    <li>  Actuar siempre con la verdad y objetivamente.</li>
                    <li> Actuar con integridad y ser profesionales.</li>
                    <li>Vivir comprometidos con el ambiente.</li>
                    <li>Crear soluciones adaptadas al contexto del país y de nuestros clientes.</li>
                    <li>Dar asesoramiento de alto nivel.</li>

                </ul>
            </div>

            <div className={style["title"]}>
                Nuestros Compromisos

            </div>
            <div className={style["text"]}>
                <ul>
                    <li>Mantener confidencialidad con la información de nuestros clientes.</li>
                    <li>  Mantener al mejor talento humano y sus conocimientos siempre actualizados.</li>


                </ul>
            </div>

            <div className={style["title"]}>
                Historia

            </div>
            <div className={style["text"]}>
                En el año 2012 nace Green Wise de la mano de tres profesionales apasionados con la iniciativa de implantar una cultura de sostenibilidad en el Ecuador. Al ser un equipo multidisciplinario se logró generar una propuesta de valor que integra diversas visiones sobre el desarrollo sostenible.


            </div>
            <div className={style["text"]}>
              
                Unificamos nuestros conocimientos de ambiente, procesos, responsabilidad corporativa, marketing, comunicación, entre otros, para brindar servicios ambientales de alto nivel aplicables a la realidad nacional y generar acciones concretas que promuevan la conservación de nuestro planeta.


            </div>
            <div className={style["text"]}>
               
                Fiel a nuestra visión nos consolidamos en el mercado nacional para ayudar a nuestros clientes en el camino que tanto nos apasiona.
            
            </div>

        </div>

    );
};


export default Welcome;